import React, { forwardRef } from 'react';
import { OverlayHighlight, OverlayHighlightHandle } from '../OverlayHighlight';
import { Box, Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';

interface ClickAreaHighlightProps
  extends Omit<
    React.ComponentProps<typeof OverlayHighlight>,
    'tooltipContent' | 'backgroundColor'
  > {
  totalClicks: number;
  popoverContent: string[];
}

const ClickAreaPopoverContent = ({ tooltipContent }: { tooltipContent: string[] }) => (
  <Box data-component="ClickAreaPopoverContent" padding={[8, 16]}>
    {tooltipContent.map(item => (
      <Text appearance="bodySmallBold" key={item} color="default-inverse">
        {item}
      </Text>
    ))}
  </Box>
);

export const ClickAreaHighlight = forwardRef<OverlayHighlightHandle, ClickAreaHighlightProps>(
  (
    { selected = false, clickOverlayDetail, totalClicks, popoverContent, ...overlayHighlightProps },
    forwardRef,
  ) => {
    const percentStr = intl.formatNumber(
      clickOverlayDetail.elementStats.NumClicks / totalClicks || 0,
      {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
    );

    return (
      <OverlayHighlight
        data-component="ClickAreaHighlight"
        {...overlayHighlightProps}
        ref={forwardRef}
        clickOverlayDetail={clickOverlayDetail}
        selected={selected}
        tooltipContent={<ClickAreaPopoverContent tooltipContent={popoverContent} />}
        tooltipOpen={selected}
        tooltipVariant="dark"
        colorClass={clickOverlayDetail.color}
      >
        {percentStr}
      </OverlayHighlight>
    );
  },
);

ClickAreaHighlight.displayName = 'ClickAreaHighlight';
